<template>
  <v-list class="profil-select py-0">
    <v-list-item v-for="profil in profils" :key="profil.key" class="px-0">
      <v-col class="px-5 separation-line mb-0">
        <v-row @click="selectedProfil(profil)" :class="getCurrentProfil(profil) ? 'current-profile' : 'cursor-pointer'">
          <v-col class="col-12 py-3">
            <div style="cursor: pointer;">
              <v-icon :class="getCurrentProfil(profil) ? 'current-profile pe-2' : 'pe-2'" size="24">
                fas fa-user
              </v-icon>
              {{ profil.title }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import UserProfile, {EnumProfile} from '@/framework/base/classes/UserProfile';
import Item from '@/framework/base/classes/Item';
import User from '@/generated/classes/User';
import {storeSession} from '@/generated/stores';
import {FwkControls, RessourceFwkControl} from '@/ressources/globalRessources';
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  computed: {
    profils(): Item[] {
      const res: Item[] = [];
      const user = storeSession.connectedUser;
      if (user != undefined) {
        Object.values(UserProfile.listProfile(user)).forEach((value) => {
          if (typeof (value) == 'number') {
            if (value == EnumProfile.client) {
              res.push(new Item(value, RessourceFwkControl(FwkControls.EMPLOYEUR).label))
            } else if (value == EnumProfile.salarie) {
              res.push(new Item(value, RessourceFwkControl(FwkControls.SALARIE).label))
            } else if (UserProfile.IsInterne(user)) {
              res.push(new Item(value, RessourceFwkControl(FwkControls.INTERNE).label))
            }
          }
        });
      }
      return res;
    }
  },
  data() {
    return {
      router: useRouter(),
      route: useRoute()
    }
  },
  methods: {
    getCurrentProfil(item: Item): boolean {
      let res = false;
      const userString = localStorage.getItem("user");
      if (userString) {
        const userData = JSON.parse(userString);
        const currentProfil = userData.user.currentProfil;
        if ((currentProfil & item.key) > 0) {
          res = true
        }
      }
      return res;
    },
    selectedProfil(item: Item) {
      if (!this.getCurrentProfil(item)) {
        storeSession.stopHubCx();
        User.setProfil(item.key).then((user) => {
          storeSession.clearStoresData();
          storeSession.startHubCx();
          const userString = localStorage.getItem("user");
          if (userString) {
            // vérifier s'il y a bien un utilisateur
            const userData = JSON.parse(userString); // Analyser les données utilisateur dans JSON
            if (userData.user) {
              userData.user = user;
              storeSession.clearData();
              storeSession.setUserData(userData)
              if (this.route.name != "Dashboard") {
                this.router.push({name: "Dashboard"});
              } else {
                this.router.go(0)
              }
            }
          }
        })
      }
    }
  }
})

</script>
